import api from '@/utils/api';

/**
 * 取得所有員工帳戶資料
 * @returns {Object[]}
 */
export async function fetchAllEmployee() {
    try {
        const resp = await api({
            url: '/PaymentManagenmentPage/GetFullStaffBankInfo',
            method: 'GET',
        });
        if (resp && resp.data && resp.data.items) {
            return resp.data.items;
        }
        return [];
    } catch (ex) {
        return [];
    }
}

/**
 * 取得單筆員工帳戶資料
 * @param {number}  sno - 員工sno
 * @returns {Object | null} 員工資料
 */
export async function getStaffBySno(sno) {
    try {
        const resp = await api({
            url: `/PaymentManagenmentPage/GetStaffBankInfo?sno=${sno}`,
            method: 'GET',
        });
        if (resp && resp.data && resp.data.item) {
            return resp.data.item;
        }
        return null;
    } catch (ex) {
        console.error(`找不到該員工資料(${sno})`);
        console.log(ex);
        return null;
    }
}

/**
 * 取得所有委外廠商資料
 * @returns {Object[]}
 */
export async function getAllOutsourcingCompany() {
    try {
        const resp = await api({
            url: '/PaymentManagenmentPage/GetVendorOutsourcingList',
            method: 'GET',
            params: { PageSize: 999, PageNum: 1 },
        });
        if (resp && resp.data && resp.data.items) {
            return resp.data.items;
        }
        return [];
    } catch (ex) {
        return [];
    }
}

/**
 * 取得單筆委外廠商資料
 * @param {number}  sno - 委外廠商sno
 * @returns {Object | null} 委外廠商資料
 */
export async function getOutsourcingCompanyBySno(sno) {
    try {
        const resp = await api({
            url: `/PaymentManagenmentPage/GetVendorOutsourcing?sno=${sno}`,
            method: 'GET',
        });
        if (resp && resp.data && resp.data.item) {
            return resp.data.item;
        }
        return null;
    } catch (ex) {
        console.error(`找不到該委外廠商資料(${sno})`);
        console.log(ex);
        return null;
    }
}

/**
 * 取得所有委外個人資料
 * @returns {Object[]}
 */
export async function getAllOutsourcingPerson() {
    try {
        const resp = await api({
            url: '/PaymentManagenmentPage/GetPersonalOutsourcingList',
            method: 'GET',
            params: { PageSize: 999, PageNum: 1 },
        });
        if (resp && resp.data && resp.data.items) {
            return resp.data.items;
        }
        return [];
    } catch (ex) {
        return [];
    }
}

/**
 * 取得單筆委外個人資料
 * @param {number}  sno - 委外個人sno
 * @returns {Object | null} 委外個人資料
 */
export async function getOutsourcingPersonBySno(sno) {
    try {
        const resp = await api({
            url: `/PaymentManagenmentPage/GetPersonalOutsourcing?sno=${sno}`,
            method: 'GET',
        });
        if (resp && resp.data && resp.data.item) {
            return resp.data.item;
        }
        return null;
    } catch (ex) {
        console.error(`找不到該委外個人資料(${sno})`);
        console.log(ex);
        return null;
    }
}
